import { render, staticRenderFns } from "./OfficeInvoiceStaff.vue?vue&type=template&id=6051fc56&scoped=true&"
import script from "./OfficeInvoiceStaff.vue?vue&type=script&lang=ts&"
export * from "./OfficeInvoiceStaff.vue?vue&type=script&lang=ts&"
import style0 from "./OfficeInvoiceStaff.vue?vue&type=style&index=0&id=6051fc56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6051fc56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
